var _defs, _path, _path2, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack195({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;}.b,.c,.d{stroke:#fff;stroke-miterlimit:10;}.c,.d{stroke-width:0.5px;}.c{fill:url(#a);}.d{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 8,
    x2: 8.57,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 183.85,
    y1: -182.2,
    x2: 192.42,
    y2: -182.2,
    gradientTransform: "translate(-177.92 -180.13) rotate(90)",
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.32,9.07l.6-2.87h1.86l-.07.33H10.23L10,7.44h1.51l-.07.33H10l-.27,1.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.26,9.07,12.08,6.2h.39l.07,1.42c0,.07,0,.25,0,.55v.37c.16-.33.27-.56.34-.69l.88-1.65h.39l.1,1.68c0,.19,0,.42,0,.69a2.28,2.28,0,0,1,.12-.3l.21-.45.82-1.62h.39L14.37,9.07H14l-.09-1.74c0-.15,0-.33,0-.54-.08.18-.15.32-.2.42l-1,1.86Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4.28,
    cy: 8,
    r: 2.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    y1: 8,
    x2: 8.57,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 4.28,
    y1: 3.72,
    x2: 4.28,
    y2: 12.28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack195);
export default __webpack_public_path__ + "static/media/Symbolpack_1_95.ea568d0b2283e213d72ed56b7edea38c.svg";
export { ForwardRef as ReactComponent };